import {
  ApiGetRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../api';
// import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Dashboard',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
    ],
    showmodal: false,
    loading: false,
    pending_email: 0,
    pending_edi: 0,
    failed_email: 0,
    failed_edi: 0,
    dashedLineChart: {
      series: [
        {
          name: 'EDI',
          data: [],
        },
        {
          name: 'Email',
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ['#556ee6', '#ff5722'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [3, 3],
          curve: 'straight',
          dashArray: [0, 0],
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function(val) {
                  return val;
                },
              },
            },
            {
              title: {
                formatter: function(val) {
                  return val;
                },
              },
            },
          ],
        },
        grid: {
          borderColor: '#f1f1f1',
        },
      },
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeDashboard(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getPendingEmail({ commit }) {
    commit('changeDashboard', {
      loading: true,
    });

    let result = await ApiGetRequest(`conf/dashboard/pending-email`);
    commit('changeDashboard', {
      pending_email: result.data.object,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getPendingEdi({ commit }) {
    commit('changeDashboard', {
      loading: true,
    });

    let result = await ApiGetRequest(`conf/dashboard/pending-edi`);
    commit('changeDashboard', {
      pending_edi: result.data.object,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getFailedEmail({ commit }) {
    commit('changeDashboard', {
      loading: true,
    });

    let result = await ApiGetRequest(`conf/dashboard/failed-email`);
    commit('changeDashboard', {
      failed_email: result.data.object,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getFailedEdi({ commit }) {
    commit('changeDashboard', {
      loading: true,
    });

    let result = await ApiGetRequest(`conf/dashboard/failed-edi`);
    commit('changeDashboard', {
      failed_email: result.data.object,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getChart({ commit, state }) {
    commit('changeDashboard', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`conf/dashboard/dashboard-chart`);
    if (!result.error) {
      commit('changeDashboard', {
        dashedLineChart: {
          ...data.dashedLineChart,
          series: [
            {
              name: 'EDI',
              data: result.data.object.edi,
            },
            {
              name: 'Email',
              data: result.data.object.email,
            },
          ],
          chartOptions: {
            chart: {
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: false,
              },
            },
            colors: ['#556ee6', '#ff5722'],
            dataLabels: {
              enabled: false,
            },
            stroke: {
              width: [3, 3],
              curve: 'straight',
              dashArray: [0, 0],
            },
            markers: {
              size: 0,
              hover: {
                sizeOffset: 6,
              },
            },
            xaxis: {
              categories: result.data.object.categories,
            },
            tooltip: {
              y: [
                {
                  title: {
                    formatter: function(val) {
                      return val;
                    },
                  },
                },
                {
                  title: {
                    formatter: function(val) {
                      return val;
                    },
                  },
                },
              ],
            },
            grid: {
              borderColor: '#f1f1f1',
            },
          },
        },
        loading: false,
      });
    } else {
      commit('changeDashboard', {
        loading: false,
      });
    }

    return !result.error ? true : false;
  },
};
